var controller = new ScrollMagic.Controller();

$(function() {

    // diagnal animation
    var scene = new ScrollMagic.Scene({
        triggerElement: ".animate-rotate-left", duration: 200
    })
    .setTween(".animate-rotate-left", {
        rotation: -2,
        scale: 1,
    })
    .addTo(controller);


    // diagnal animation
    var scene = new ScrollMagic.Scene({
        triggerElement: ".animate-rotate-right", duration: 200
    })
    .setTween(".animate-rotate-right", {
        rotation: 2,
        scale: 1,
    })
    .addTo(controller);


    // scale up animation
    var scene = new ScrollMagic.Scene({
        triggerElement: ".animate-pan-lr", duration: 200
    })
    .setTween(".animate-pan-lr", {
        marginRight: 50,
    })
    .addTo(controller);


    // slide from bottom to top
    var scene = new ScrollMagic.Scene({
        triggerElement: ".animate-mask-up",
        duration: 0,
        offset: 0,
        triggerHook: "onEnter",
        reverse: false
    })
    .setTween(".animate-mask-up span", {
        marginBottom: 0,
    })
    .addTo(controller);


    // Fade opacity
    $('.animate-fadein-note').each(function() {

        var tween = TweenMax.from($(this), .8, {
            autoAlpha: 0,
            ease:Linear.easeInOut
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });


    // Fade opacity
    $('.animate-fadein').each(function() {

        var tween = TweenMax.from($(this), .8, {
            autoAlpha: 0,
            ease:Linear.easeInOut
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.8,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });


    // Fade element in and up
    $('.animate-fadein-up').each(function() {

        var tween = TweenMax.from($(this), 0.5, {
            autoAlpha: 0,
            y: '+=100', x: '0',
            ease:Linear.easeInOut
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.9,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });


    // Fade elements in and up with a stagger effect
    const elements = $('.animate-fadein-up-stagger');

    elements.each(function(index) {
        const tween = TweenMax.from($(this), 0.7, { // Increased duration slightly
            autoAlpha: 0,
            y: '+=100',
            x: '0',
            ease: Power2.easeOut, // Softer ease-out effect
            delay: index * 0.3 
        });

        const scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.9,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });


    // Fade element in and up
    $('.animate-fadein-left').each(function() {

        var tween = TweenMax.from($(this), 1.8, {
            autoAlpha: 0,
            y: '0', x: '+=100',
            ease: Circ.easeOut
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.8,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });


    // Fade element in and right
    $('.animate-fadein-right').each(function() {

        var tween = TweenMax.from($(this), 1.8, {
            autoAlpha: 0,
            y: '0', x: '-=100',
            ease: Circ.easeOut
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.8,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .setClassToggle(this, 'is-animated')
        .addTo(controller);
    });


    // Adds .is-visible class to italic elements within paragraphs
    // $('p em').each(function() {
    //     new ScrollMagic.Scene({
    //         duration: 0,
    //         reverse: true,
    //         triggerElement: this,
    //         triggerHook: .8,
    //     })
    //     .setClassToggle(this, "is-visible")
    //     .addTo(controller);
    // });

    // Iterate over each <em> with the .scribble-underline class
    $('p em').each(function() {
        var textLength = $(this).text().length;
        
        // Determine which SVG to apply based on the character count
        if (textLength <= 5) {
            $(this).addClass('short');
        } else if (textLength <= 15) {
            $(this).addClass('medium');
        } else if (textLength <= 30) {
            $(this).addClass('long');
        } else {
            $(this).addClass('extra-long');
        }

        // Create a ScrollMagic scene to trigger the is-visible class
        new ScrollMagic.Scene({
            duration: 0,
            reverse: true,
            triggerElement: this,
            triggerHook: 0.8
        })
        .setClassToggle(this, 'is-visible')
        .addTo(controller);
    });


    // Adds .is-visible class when in view
    $('[data-animate="is-visible"]').each(function() {
        new ScrollMagic.Scene({
            duration: 0,
            reverse: true,
            triggerElement: this,
            triggerHook: .7,
        })
        .setClassToggle(this, "is-visible")
        .addTo(controller);
    });


    // Adds .is-visible class when in view
    $('[data-animate="in-view-50"]').each(function() {
        new ScrollMagic.Scene({
            duration: '70%',
            offset: 50,
            reverse: true,
            triggerElement: this,
            triggerHook: .7,
        })
        .setClassToggle(this, "is-visible")
        .addTo(controller);

        new ScrollMagic.Scene({
            duration: 0,
            reverse: true,
            triggerElement: this,
            triggerHook: "onLeave",
        })
        .setClassToggle(this, "has-exited")
        .addTo(controller);
    });


    // Adds .is-visible class when in view
    $('.js-sticky-block-button').each(function() {
        var elementHeight = $(this).outerHeight();

        new ScrollMagic.Scene({
            duration: 0,
            offset: elementHeight,
            reverse: true,
            triggerElement: this,
            triggerHook: "onEnter",
        })
        .setClassToggle(this, "has-exited")
        .addTo(controller);

        new ScrollMagic.Scene({
            duration: 0,
            offset: elementHeight + 200,
            reverse: true,
            triggerElement: this,
            triggerHook: "onEnter",
        })
        .setClassToggle(this, "cta-enter")
        .addTo(controller);
    });


    $('[data-animate="animate-circle"]').each(function() {

        // grab data-circle value
        $this = $(this);
            var dataCircle = $(this).attr('data-circle');
            var dataSrc = ('/assets/images/scribbles/animated/' + dataCircle + '.svg')

        function animateCircle() {
            $this
                .find('.element-circle')
                .attr('data', dataSrc);
        }

        new ScrollMagic.Scene({
            duration: 0,
            reverse: false,
            triggerElement: this,
            triggerHook: .8,
        })
        .setClassToggle(this, "is-animated")
        .on("enter", function(e) {
            animateCircle();
        })
        .addTo(controller);
    });

    // text underline - heading
    $('.js-text-underline').each(function() {
        var $this = $(this); // Use 'var' to keep scope inside the loop
    
        new ScrollMagic.Scene({
            duration: 0,
            reverse: false,
            triggerElement: this,
            triggerHook: 0.8,
        })
        .on("enter", function() {
            // Check if the SVG already exists to prevent duplicate appends
            if (!$this.find('object').length) {
                $this.append('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-underline-heading.svg" height="15" width="415">Hand drawn underline</object>');
            }
        })
        .addTo(controller);
    });
    

    // fades element in based on scroll position
    $('.animate-fadein-scroll').each(function() {
        var tween = TweenMax.from($(this), 0.5, {
            autoAlpha: 0,
            ease:Linear.easeInOut
        });
        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            duration: "25%",
            triggerHook: 0.6,
            offset: 0,
            reverse: true
        })
        .setTween(tween)
        .addTo(controller);
    });

    // Adds double underline graphic
    $('.js-text-double-underline').each(function() {
        let $element = $(this); // Store reference to the jQuery object
        let originalSrc = $element.attr("src"); // Store the original src

        new ScrollMagic.Scene({
            duration: 0,
            reverse: true, // Ensures the event fires when leaving the view
            triggerElement: this,
            triggerHook: 0.7,
        })
        .on("enter", function() {
            let newSrc = $element.attr("data-src"); // Get new image from data-src
            if (newSrc) {
                $element.attr("src", newSrc);
            }
        })
        .on("leave", function() {
            // Optional: Reset to original image when leaving
            $element.attr("src", originalSrc);
        })
        .addTo(controller);
    });

});
